/**
 * エラーハンドリング共通型定義
 *
 * @module types/error
 * @created 2025-11-27
 */

/**
 * 正規化されたエラー構造
 */
export interface NormalizedError {
  /** ユーザー向けエラーメッセージ */
  message: string;
  /** HTTPステータスコード */
  statusCode?: number;
  /** フィールド別バリデーションエラー */
  fieldErrors?: FieldError[];
  /** 認証エラーかどうか */
  isAuthError?: boolean;
  /** ネットワークエラーかどうか */
  isNetworkError?: boolean;
}

/**
 * フィールド別エラー
 */
export interface FieldError {
  /** フィールド名（API側の名前） */
  field: string;
  /** エラーメッセージ */
  message: string;
  /** 日本語ラベル */
  label?: string;
}

/**
 * フィールド名の日本語ラベルマッピング
 * UserManagementPageの既存実装を参考に統合
 */
export const FIELD_LABELS: Record<string, string> = {
  // 従業員関連
  employee_id: '社員ID',
  name: '氏名',
  email: 'メールアドレス',
  password: 'パスワード',
  hire_date: '入社日',
  department_id: '部門ID',
  job_title: '役職',
  job_grade: '職級',
  rank: 'ランク',
  roles: 'ロール',

  // 評価関連
  evaluation_period_id: '評価期間',
  self_score: '自己評価スコア',
  manager_score: '上長評価スコア',
  dept_score: '部門長評価スコア',
  comment: 'コメント',

  // スキル関連
  skill_category_id: 'スキルカテゴリ',
  skill_item_id: 'スキル項目',
  skill_level: 'スキルレベル',
  certification_name: '資格名',
  certification_number: '資格番号',
  acquired_date: '取得年月',
  expiry_date: '有効期限',
  issuing_organization: '発行機関',
  rejected_reason: '差し戻し理由',
  rejection_reason: '差し戻し理由',

  // プロジェクト歴関連
  start_date: '開始年月',
  end_date: '終了年月',
  role: '役割',
  responsibilities: '担当業務の詳細',
  technologies: '使用技術・ツール',
  project_description: 'プロジェクト概要',

  // 営業案件関連
  case_name: '案件名',
  case_no: '案件番号',
  account_id: '取引先',
  phase_id: 'フェーズ',
  expected_order_amount: '受注見込金額',
  expected_close_date: '受注予定日',
  business_category: '業種区分',

  // 予算関連
  fiscal_year: '年度',
  project_name: 'プロジェクト名',
  project_no: 'PJT No',
  target_sales: '目標売上',
  target_cost: '目標原価',
  unit_price: '売単価',
  cost_rate: '原価',
  start_month: '開始月',
  end_month: '終了月',
  resource_name: '要員名',
  resource_type: '要員種別',
  vendor_id: '発注先',

  // 部門関連
  department_name: '部門名',
  department_type: '部門種別',
  manager_id: '部門長',

  // 共通
  notes: '備考',
  status: 'ステータス',
};
